// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__38r5T","notes":"Notes_notes__Y8M5n","note":"Notes_note__3FrPS","markdown":"Notes_markdown__3RXBx"};